<script lang="ts">
    import { onMount } from 'svelte';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    import { resetLabels, resetValues } from './utils';

    export let searchResultTotal: number | null,
        searchDatalayer: string = '';

    onMount(() => {
        if (searchResultTotal && searchResultTotal === 0 && window.dataLayer) {
            window.dataLayer.push(JSON.parse(searchDatalayer));
        }
    });

    const resetFilters = () => {
        $filtersContext.formLabels = resetLabels();
        $filtersContext.formValues = resetValues();

        // trigger form with event
        const form = document.getElementById(
            'travel-search-engine-form',
        ) as HTMLFormElement | null;
        if (form) {
            setTimeout(() => {
                form.requestSubmit();
            }, 0);
        }
    };
</script>

{#if searchResultTotal}
    <div class="text-xl font-semibold desktop:text-2xl">
        <span class="placeholder italic text-content-brand">
            {trans('search.counter.count', {
                '%count%': searchResultTotal,
            })}
        </span>
        <span>
            {trans('search.counter.suffix', {
                '%count%': searchResultTotal,
            })}
        </span>
    </div>
{/if}

{#if searchResultTotal != null && searchResultTotal === 0}
    <div
        class="mb-2xl flex flex-col items-center justify-center gap-m bg-white p-l desktop:justify-start"
    >
        <span class="text-center">
            {trans('search.counter.no_results')}
        </span>

        <Button
            intent="tertiary"
            size="small"
            class="text-caption underline hover:no-underline"
            on:click={resetFilters}
        >
            {trans('search.counter.reset_filters')}
        </Button>
    </div>
{/if}
